import React from "react";
import { Link } from "react-router-dom";

export default function Signup() {
	return (
		<div className="signup">
			<form className="form">
				<p className="form-title">Sign up</p>
				<div className="form-field">
					<label htmlFor="user-email" className="field-label">
						Email
					</label>
					<input
						type="email"
						name="user-email"
						id="user-email"
						className="field-input"
						placeholder="you@example.com"
					/>
				</div>
				<div className="form-field">
					<label htmlFor="user-password" className="field-label">
						Password
					</label>
					<input
						type="email"
						name="user-password"
						id="user-password"
						className="field-input"
						placeholder="**********"
					/>
				</div>
				<button className="form-submit-button">Sign up</button>
			</form>
			<Link to="/login" className="link">already have an account?</Link>
		</div>
	);
}
